<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li *ngIf="user.role === 'ACCOUNT_OWNER'" class="breadcrumb-item" id="accountOwnerHome"><a
        routerLink="/admin/dashboard/">Home</a></li>
      <li *ngIf="user.role === 'ROLE_USER'" class="breadcrumb-item" id="userHome"><a
        routerLink="/admin/dashboard/">Home</a></li>
      <li aria-current="page" class="breadcrumb-item active">My Accounts</li>
    </ol>
  </nav>
  <form>
    <div class="row">
      <div class="col">
        <ul class="list-inline tab-list deskContent">
          <ng-container *ngFor="let om of ordersMainMenu">
            <li *ngIf="om.additional === 'N'" class="list-inline-item">
              <a (click)="populateTabData(om.tabClicked); getOrder(om.orderStatus);resetCheckedList()"
                 [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a></li>
          </ng-container>
        </ul>
        <select (change)="populateTabData(userDrop2);" [(ngModel)]="userDrop2" [ngModelOptions]="{standalone: true}"
                class="form-control MobileContent" id="use2r" required
                style="width: 140px;">
          <option *ngFor="let u of allOrdersMainMenu" [ngValue]="u.tabClicked">{{u.displayName}}</option>
        </select>
      </div>
    </div>
    <div [ngClass]="{'show-sec': tabClicked === 'profile'}" class="row hide-sec">
      <div class="col">
        <div [hidden]="profileStep != 1" class="inner-box">
          <div class="row mt-3">

            <div class="col-md-4 required">
              <div *ngIf="user.role ==='ROLE_USER'" class="form-group">
                <div>Name</div>
                <div class="font-weight-bold">{{account.ownerName}}</div>
              </div>
              <div *ngIf="user.role !=='ROLE_USER'" class="form-group required">
                <label class="control-label" for="firstName">Contact Name</label>
                <input (blur)="typeContactName()" [(ngModel)]="account.ownerName"
                       [ngClass]="{'is-invalid':contactError}" [ngModelOptions]="{standalone: true}"
                       class="form-control"
                       id="firstName" maxlength="50"
                       required type="text">
                <div [hidden]="!contactError" class="invalid-feedback d-block shift-invalid-login" id="contactError">
                  {{contactError}}
                </div>
              </div>
            </div>
            <div class="col-md-4 required">
              <div *ngIf="user.role ==='ROLE_USER'" class="form-group">
                <div>Company Name</div>
                <div class="font-weight-bold">{{account.companyName}}</div>
              </div>
              <div *ngIf="user.role !=='ROLE_USER'" class="form-group required">
                <label class="control-label" for="companyName">Company Name</label>
                <input (blur)="typeCompanyName()" [(ngModel)]="account.companyName"
                       [ngClass]="{'is-invalid':companyNameError}" [ngModelOptions]="{standalone: true}"
                       class="form-control" disabled
                       id="companyName" required type="text">
                <div [hidden]="!companyNameError" class="invalid-feedback d-block shift-invalid-login"
                     id="companyNameError">{{companyNameError}}
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div>&nbsp;&nbsp;</div>
              <div class="text-center mt-1">
                <button (click)="openDeletePopup()" class="btn btn-cancel" id="delete" ngbTooltip="Delete my account"
                        placement="bottom" type="submit"><i class="fa fa-trash-o"
                                                            style="color:#ee7125"></i>
                </button>
              </div>
            </div>
          </div>
          <div [ngStyle]="{'padding-left':(user.role ==='ROLE_USER')?'0px':'0px'}" class="row">
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="email">Email</label>
                <input (blur)="typeEmail()" [(ngModel)]="account.email" [ngClass]="{'is-invalid':emailError}"
                       [ngModelOptions]="{standalone: true}" class="form-control"
                       id="email" required type="text">
                <div [hidden]="!emailError" class="invalid-feedback d-block shift-invalid-login" id="emailError">
                  {{emailError}}
                </div>
              </div>
            </div>
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="mobile">Phone Number</label>
                <input (blur)="typePhoneNumber()" [(ngModel)]="account.mobile" [ngClass]="{'is-invalid':mobileError}"
                       [ngModelOptions]="{standalone: true}" appOnlyNumbers
                       class="form-control" id="mobile" maxlength="10"
                       required type="text">

                <div [hidden]="!mobileError" class="invalid-feedback d-block shift-invalid-login" id="mobileError">
                  {{mobileError}}
                </div>
              </div>
            </div>
            <div class="col-md-4 text-center mt-4">

              <div>
                <label class="ms-4" *ngIf="account?.panCard != 'NO'"><i class="fa fa-file-pdf-o mr-2"
                                                                        style="color:#8f5cbe;font-weight: 600;"></i>
                  <a href="{{account?.panCard}}" target="_blank">Pan Card</a>
                </label>
              </div>

              <div>
                <label class="ms-4" *ngIf="account?.aadharCard != 'NO'"><i class="fa fa-file-pdf-o mr-2"
                                                                           style="color:#8f5cbe;font-weight: 600;"></i>
                  <a href="{{account?.aadharCard}}" target="_blank">Aadhar Card</a>
                </label></div>

              <div>
                <label class="ms-4" *ngIf="account?.mouDocument != 'NO'"><i class="fa fa-file-pdf-o mr-2"
                                                                            style="color:#8f5cbe;font-weight: 600;"></i>
                  <a href="{{account?.mouDocument}}" target="_blank">Mou document</a></label></div>
            </div>
          </div>
          <div *ngIf="user.role !=='ROLE_USER'" class="row mt-3">
            <div class="col-md-4">
              <div class="form-group ">
                <label class="control-label" for="website">Website</label>
                <input [(ngModel)]="account.website" [ngModelOptions]="{standalone: true}" class="form-control"
                       id="website"
                       required type="text">
              </div>
            </div>
            <div class="col-md-3">
              <label>&nbsp;</label>
              <div *ngIf="!account.imageUrl" class="upload-box" id="uploadLogo">
                <input (change)="loadImage($event)" type="file">
                <svg class="bi bi-plus" fill="currentColor" height="2em" viewBox="0 0 16 16" width="2em"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                    fill-rule="evenodd"/>
                </svg>
                <div>Upload Logo</div>
              </div>
              <div *ngIf="account.imageUrl" class="upload-box mt-2">
                <img class="shift-uploaded-img shift-image" style="width:100%; height:100%"
                     src="{{account.imageUrl !=null ? account.imageUrl : 'https://carrier-prod-images.s3.ap-south-1.amazonaws.com/default'}}"/>
                <div [hidden]="!errorMessage" class="invalid-feedback d-block shift-invalid-text">{{errorMessage}}</div>
                <div class="overly">
                  <button class="btn">
                    <input (change)="loadImage($event)" class="plus-upload-btn" type="file">
                    <svg class="bi bi-plus" fill="currentColor" height="2em" viewBox="0 0 16 16" width="2em"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                        fill-rule="evenodd"/>
                    </svg>
                    Upload
                  </button>
                  <button (click)="ignoreImage()" class="btn">
                    <svg class="bi bi-plus" fill="currentColor" height="2em" viewBox="0 0 16 16" width="2em"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                        fill-rule="evenodd"/>
                    </svg>
                    Remove
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="user.role !=='ROLE_USER'" class="mt-3">
            <div class="col text-right">
              <button (click)="editAccountOwner()" class="btn btn-orange" id="save" type="submit">Save</button>

            </div>
          </div>
        </div>
        <div [hidden]="profileStep != 2" class="inner-box">
          <h2 class="mb-2">Delete my account</h2>
          <label>Hi <span> Account owner name</span></label>
          <p>We're sorry to here you 'd like to delete your account</p>
          <p class="mb-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
            labore et dolore magna aliqua.</p>
          <h2 class="mb-2">Keep your data safe</h2>
          <p class="mb-2">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
            labore et dolore magna aliqua.</p>
          <div class="deskContent">
            <div class="form-group mb-4" style="display:flex;">
              <label class="control-label" style="margin-top:5px;width:25%">why are you deleting your account?
                : </label>
              <ng-select id="accountOwner" style="width: 30%;">
                <ng-template let-item="item" ng-option-tmp>
                  Something Else <br/>

                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="form-group mb-4 MobileContent">
            <label class="control-label">why are you deleting your account? : </label>
            <ng-select id="accountOwner">
              <ng-template let-item="item" ng-option-tmp>
                Something Else <br/>

              </ng-template>
            </ng-select>
          </div>
          <span class="mb-3">Please consider the following articles in our Help Center before permanently deleting your account</span><br>
          <li><a href="#">Tips for getting started</a></li>
          <div class="deskContent">
            <div class="form-group mt-4" style="display:flex;">
              <label class="mt-1 control-label" style="width: 25%;">To continue, Please re-enter your password
              </label>

              <input class="form-control" id="password" placeholder="Password" required style="width: 30%;"
                     type="password">
            </div>
          </div>
          <div class="form-group mt-4 MobileContent">
            <label class="mt-1 control-label">To continue, Please re-enter your password
            </label>

            <input class="form-control" id="password1" placeholder="Password" required type="password">
          </div>

          <a href="#">Forget Password</a>
          <p class="mb-2 mt-2">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua.</p>

          <div *ngIf="user.role !=='ROLE_USER'" class="mt-3">
            <div class="col text-right">
              <button (click)="profileMenu()" class="btn btn-cancel mr-2" type="submit">Cancel</button>
              <button class="btn btn-orange" style="width:20%!important;" type="submit">Permanent Delete my account
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div [ngClass]="{'show-sec': tabClicked === 'bankAccountInfo'}" class="row hide-sec">
      <div class="col">
        <div [hidden]="profileStep != 1" class="inner-box">
          <div class="row mt-3">

            <div class="col-md-4 required">

              <div *ngIf="user.role !=='ROLE_USER'" class="form-group required">
                <label class="control-label" for="accountType">Account Type</label>
                <select id="accountTypeId" class="form-control" [(ngModel)]="bank.accountType"
                        (blur)="typeAccountType()"
                        [ngModelOptions]="{standalone: true}" [ngClass]="{'is-invalid':accountTypeError}" required>
                  <option *ngFor="let c of accountTypeList" [ngValue]="c.config">{{c.config}}</option>
                </select>
                <div [hidden]="!accountTypeError" class="invalid-feedback d-block shift-invalid-login" id="accountType">
                  {{accountTypeError}}
                </div>
              </div>
            </div>
            <div class="col-md-4 required">

              <div *ngIf="user.role !=='ROLE_USER'" class="form-group required">
                <label class="control-label" for="accountName">Account Name</label>
                <input (blur)="typeAccountName()" [ngClass]="{'is-invalid':accountNameError}"
                       [(ngModel)]="bank.accountName" [ngModelOptions]="{standalone:true}"
                       class="form-control"
                       id="accountName" required type="text">
                <div [hidden]="!accountNameError" class="invalid-feedback d-block shift-invalid-login"
                     id="accountNameError">{{accountNameError}}
                </div>
              </div>
            </div>

            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="accountNo">Account Number</label>
                <input (blur)="typeAccountNumber()" [(ngModel)]="bank.accountNumber"
                       [ngModelOptions]="{standalone :true}" [ngClass]="{'is-invalid':accountNumberError}"
                       class="form-control"
                       id="accountNo" maxlength="11"
                       required type="text" appOnlyNumbers>
                <div [hidden]="!accountNumberError" class="invalid-feedback d-block shift-invalid-login"
                     id="accountNumberError">
                  {{accountNumberError}}
                </div>
              </div>
            </div>


          </div>
          <div [ngStyle]="{'padding-left':(user.role ==='ROLE_USER')?'0px':'0px'}" class="row">

            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="bankName">Bank Name</label>
                <input (blur)="typeBankName()" [(ngModel)]="bank.bankName" [ngModelOptions]="{standalone:true}"
                       [ngClass]="{'is-invalid':bankNameError}"
                       class="form-control" id="bankName" maxlength="30"
                       type="text"
                       onkeypress='return event.charCode >= 90 && event.charCode <= 122 || event.charCode >= 65 && event.charCode <=90'
                       required type="text">

                <div [hidden]="!bankNameError" class="invalid-feedback d-block shift-invalid-login" id="bankNameError">
                  {{bankNameError}}
                </div>
              </div>
            </div>

            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="ifsc">IFSC Code</label>
                <input (blur)="typeIfscCode()" [(ngModel)]="bank.ifscCode" [ngModelOptions]="{standalone: true}"
                       [ngClass]="{'is-invalid':ifscError}"
                       class="form-control" id="ifsc" maxlength="11" size="11"
                       required type="text">

                <div [hidden]="!ifscError" class="invalid-feedback d-block shift-invalid-login" id="ifscError">
                  {{ifscError}}
                </div>
              </div>
            </div>


            <div class="col-md-4">
              <div class="form-group w-50 verified" *ngIf="bank?.accountVerified === 'N'">Not verified</div>
              <div class="form-group w-50 verified1" *ngIf="bank?.accountVerified === 'Y'">Verified</div>
            </div>

          </div>

          <div *ngIf="user.role !=='ROLE_USER'" class="mt-3">
            <div class="col text-right">
              <button class="btn btn-orange" (click)="manageBankAccount()" type="submit">Save</button>

            </div>
          </div>
        </div>
        <div [hidden]="profileStep != 2" class="inner-box">
          <h2 class="mb-2">Delete my account</h2>
          <label>Hi <span> Account owner name</span></label>
          <p>We're sorry to here you 'd like to delete your account</p>
          <p class="mb-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
            labore et dolore magna aliqua.</p>
          <h2 class="mb-2">Keep your data safe</h2>
          <p class="mb-2">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
            labore et dolore magna aliqua.</p>
          <div class="deskContent">
            <div class="form-group mb-4" style="display:flex;">
              <label class="control-label" style="margin-top:5px;width:25%">why are you deleting your account?
                : </label>
              <ng-select id="accountOwner" style="width: 30%;">
                <ng-template let-item="item" ng-option-tmp>
                  Something Else <br/>

                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="form-group mb-4 MobileContent">
            <label class="control-label">why are you deleting your account? : </label>
            <ng-select id="accountOwner">
              <ng-template let-item="item" ng-option-tmp>
                Something Else <br/>

              </ng-template>
            </ng-select>
          </div>
          <span class="mb-3">Please consider the following articles in our Help Center before permanently deleting your account</span><br>
          <li><a href="#">Tips for getting started</a></li>
          <div class="deskContent">
            <div class="form-group mt-4" style="display:flex;">
              <label class="mt-1 control-label" style="width: 25%;">To continue, Please re-enter your password
              </label>

              <input class="form-control" id="passwordMob" placeholder="Password" required style="width: 30%;"
                     type="password">
            </div>
          </div>
          <div class="form-group mt-4 MobileContent">
            <label class="mt-1 control-label">To continue, Please re-enter your password
            </label>

            <input class="form-control" id="password1Mob" placeholder="Password" required type="password">
          </div>

          <a href="#">Forget Password</a>
          <p class="mb-2 mt-2">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua.</p>

          <div *ngIf="user.role !=='ROLE_USER'" class="mt-3">
            <div class="col text-right">
              <button (click)="profileMenu()" class="btn btn-cancel mr-2" type="submit">Cancel</button>
              <button class="btn btn-orange" style="width:20%!important;" type="submit">Permanent Delete my account
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row hide-sec" [ngClass]="{'show-sec': tabClicked === 'deleteMyAccount'}">
      <div class="inner-box deskContent text-center">
        <button class="btn btn-danger" data-toggle="modal" data-target="#deleteAccount">DELETE</button>
      </div>
      <div class="inner-box MobileContent text-center">
        <button class="btn btn-danger" data-toggle="modal" data-target="#deleteAccount">DELETE</button>
      </div>
    </div>
    <div [ngClass]="{'show-sec':tabClicked === 'passwordManagement'}" class="row hide-sec">
      <div class="inner-box deskContent ">
        <div>
          <div class="row">
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="currentPassword">Current Password</label>
                <input (blur)="typeCurrentPwd()" [(ngModel)]="currentPassword"
                       [ngClass]="{'is-invalid':currentPwdError}" [ngModelOptions]="{standalone: true}"
                       class="form-control"
                       id="currentPassword" maxlength="50"
                       required type="password">
                <div [hidden]="!currentPwdError" class="invalid-feedback d-block shift-invalid-login"
                     id="currentPwdError">{{currentPwdError}}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="newPassword">New Password</label>
                <input (blur)="typeNewPwd()" [(ngModel)]="newPassword" [ngClass]="{'is-invalid':newPwdError}"
                       [ngModelOptions]="{standalone: true}" class="form-control"
                       id="newPassword" maxlength="50"
                       required
                       type="password">
                <div [hidden]="!newPwdError" class="invalid-feedback d-block shift-invalid-login" id="newPwdError">
                  {{newPwdError}}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="confirmPassword">Confirm Password</label>
                <input (blur)="typeConfirmPwd()" [(ngModel)]="confirmPassword"
                       [ngClass]="{'is-invalid':confirmPwdError}" [ngModelOptions]="{standalone: true}"
                       class="form-control"
                       id="confirmPassword" maxlength="50"
                       required type="password">
                <div [hidden]="!confirmPwdError" class="invalid-feedback d-block shift-invalid-login"
                     id="confirmPwdError">{{confirmPwdError}}
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col text-right">
              <button (click)="submitChangePassword()" class="btn btn-orange" id="change" type="button">Change</button>
            </div>
          </div>
        </div>
      </div>
      <div class="inner-box MobileContent">
        <div>
          <label class="text-black mb-3"><b>Change Password</b></label>
          <div class="row">
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="currentPassword">Current Password</label>
                <input (blur)="typeCurrentPwd()" [(ngModel)]="currentPassword"
                       [ngClass]="{'is-invalid':currentPwdError}" [ngModelOptions]="{standalone: true}"
                       class="form-control"
                       id="currentPasswordMob" maxlength="50"
                       required type="password">
                <div [hidden]="!currentPwdError" class="invalid-feedback d-block shift-invalid-login"
                     id="currentPwdErrorMob">{{currentPwdError}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="newPassword">New Password</label>
                <input (blur)="typeNewPwd()" [(ngModel)]="newPassword" [ngClass]="{'is-invalid':newPwdError}"
                       [ngModelOptions]="{standalone: true}" class="form-control"
                       id="newPasswordMob" maxlength="50"
                       required
                       type="password">
                <div [hidden]="!newPwdError" class="invalid-feedback d-block shift-invalid-login" id="newPwdErrorMob">
                  {{newPwdError}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="confirmPassword">Confirm Password</label>
                <input (blur)="typeConfirmPwd()" [(ngModel)]="confirmPassword"
                       [ngClass]="{'is-invalid':confirmPwdError}" [ngModelOptions]="{standalone: true}"
                       class="form-control"
                       id="confirmPasswordMob" maxlength="50"
                       required type="password">
                <div [hidden]="!confirmPwdError" class="invalid-feedback d-block shift-invalid-login"
                     id="confirmPwdErrorMob">{{confirmPwdError}}
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col text-right">
              <button (click)="submitChangePassword()" class="btn btn-orange" id="changeMob" type="button">Change
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div [ngClass]="{'show-sec': tabClicked === 'address'}" class="hide-sec">
      <div class="row align-items-center">
        <div class="col-8">
          <ul class="list-inline tab-list">
            <li class="list-inline-item ml-2"><a
              (click)="populateValues('active'); getAddressList('ACTIVE'); tabChange();"
              [ngClass]="{'active': addressTab === 'active'}">Active</a></li>
            <li class="list-inline-item ml-3"><a
              (click)="populateValues('in_active'); getAddressList('IN_ACTIVE'); tabChange();"
              [ngClass]="{'active': addressTab === 'in_active'}">Inactive</a></li>
            <li class="list-inline-item ml-3"><a (click)="populateValues('all'); getAddressList('ALL');tabChange();"
                                                 [ngClass]="{'active': addressTab === 'all'}">All</a></li>
          </ul>
        </div>
        <div class="col-4 text-right">
          <a *ngIf="disableButton" class="ml-2" ngbTooltip="Create" placement="bottom">
            <img routerLink="/admin/createAddress" src="assets/images/create.png"/>
          </a>
        </div>
      </div>
      <div [hidden]="!errorMessage2" class="invalid-feedback d-block shift-invalid-text">{{errorMessage2}}</div>
      <div class="inner-box d-none d-sm-block">
        <div class="row">
          <div class="col">
            <div style="overflow-x:auto">
              <table class="table">
                <thead>
                <tr>
                  <th>Address Type</th>
                  <th>Primary Address</th>
                  <th>Secondary Address</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Zip</th>
                  <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let a of addressList;let i = index;">
                  <td>
                    <a routerLink="/admin/editAddress/{{a.addressId}}">
                      <div *ngIf="a.addressType == 'BILLING'">
                        <img src="assets/images/black-bill.png">
                      </div>
                      <div *ngIf="a.addressType == 'SHIPPING'">
                        <img src="assets/images/black-truck.png" style="width:25px;margin-left: 7px;">
                      </div>
                    </a>
                  </td>
                  <td>{{a.address1}}</td>
                  <td>{{a.address2}}</td>
                  <td>{{a.city}}</td>
                  <td>{{a.state}}</td>
                  <td>{{a.zip}}</td>
                  <td>
                    <div class="toggle-2">
                      <input (click)="changeStatusAddress(a)" [checked]="a.status==='ACTIVE'"
                             class="custom-control-input"
                             class="checkbox" id="customSwitch_{{a.addressId}}"
                             name="onoffswitch" type="checkbox"/>
                      <label class="toggle" for="customSwitch_{{a.addressId}}">
                        <span>ON</span><span>OFF</span>
                      </label>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="inner-box d-block d-sm-none">
        <div class="row">
          <div class="col">
            <div style="overflow-x:auto">
              <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
                <thead>
                <tr>
                  <th>Address Type</th>
                  <th>Address 1</th>
                  <th>Address 2</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Zip</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let a of addressList;let i = index;">
                  <td><b class=" tablesaw-cell-label">Address Type </b>
                    <span class="tablesaw-cell-content"><a
                      routerLink="/admin/editAddress/{{a.addressId}}">{{a.addressType}}</a></span>
                  </td>
                  <td><b class=" tablesaw-cell-label">Address 1 </b>
                    <span class="tablesaw-cell-content">{{a.address1}}</span></td>
                  <td><b class=" tablesaw-cell-label">Address 2</b>
                    <span class="tablesaw-cell-content">{{a.address2}}</span></td>
                  <td><b class=" tablesaw-cell-label">City </b>
                    <span class="tablesaw-cell-content">{{a.city}}</span></td>
                  <td><b class=" tablesaw-cell-label">State </b>
                    <span class="tablesaw-cell-content">{{a.state}}</span></td>
                  <td><b class=" tablesaw-cell-label">Zip</b>
                    <span class="tablesaw-cell-content">{{a.zip}}</span></td>
                  <td>
                    <b class=" tablesaw-cell-label">Status</b>
                    <span class="tablesaw-cell-content">
                    <div class="custom-control custom-switch">
                      <input (click)="changeStatusAddress(a)" [checked]="a.status==='ACTIVE'"
                             class="custom-control-input"
                             id="customSwitchs_{{a.addressId}}" type="checkbox">
                      <label class="custom-control-label" for="customSwitchs_{{a.addressId}}"> </label>
                    </div>
                    </span></td>
                  <td>
                    <b class=" tablesaw-cell-label">Actions</b>
                    <span class="tablesaw-cell-content">
                    <div *ngIf="a.addressType == 'BILLING'">
                        <img src="assets/images/black-bill.png">
                    </div>
                    <div *ngIf="a.addressType == 'SHIPPING'">
                        <img src="assets/images/black-truck.png" style="width:25px">
                    </div>
                    </span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div [ngClass]="{'show-sec': tabClicked === 'warehouse'}" class="hide-sec">
      <div class="row">
        <div class="col">
          <div class="inner-box" style="overflow:overlay">
            <div class="row">
              <div class="col">
                <div style="...">
                  <table class="table">
                    <thead>
                    <tr>
                      <th>Warehouse</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Unit Cost</th>
                      <th>Units Sqft</th>
                      <th>Duration</th>
                      <th>Auto Renew</th>
                      <th>Billing Type</th>
                      <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let a of warehouses;let i = index;">
                      <td><a routerLink="/admin/warehouseSettingsView/{{a.warehouseId}}">{{a.warehouseName}}</a></td>
                      <td>{{a.startDate}}</td>
                      <td>{{a.endDate}}</td>
                      <td>{{a.cost}}</td>
                      <td>{{a.unitsAssigned}}</td>
                      <td>{{a.duration}}</td>
                      <td>{{a.autoRenewFlag ? 'Yes' : 'No'}}</td>
                      <td>{{a.billingType| titlecase}}</td>
                      <td><a (click)="defaultWarehouse(i,a)">
                        <img *ngIf="a.isDefault !== 'Yes'" src="assets/images/warehouse.png">
                        <img *ngIf="a.isDefault == 'Yes'" src="assets/images/orange-warehouse.png">
                      </a></td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="tabClicked === 'api'" class=" ">
      <app-api-settings></app-api-settings>
    </div>
    <div [ngClass]="{'show-sec': tabClicked === 'storeManagement'}" class="row hide-sec">
    </div>
    <div [ngClass]="{'show-sec': tabClicked === 'deliveryChallanSettings'}" class="row hide-sec">
    </div>
    <div *ngIf="tabClicked === 'returnSettings'" class="">
      <app-setting-returns></app-setting-returns>
    </div>
    <div [ngClass]="{'show-sec': tabClicked === 'manageUsers'}" class="row hide-sec">
      <div [hidden]="!errorMessage" class="invalid-feedback d-block shift-invalid-text w-75">{{errorMessage}}</div>
      <div class="row align-items-center">
        <div class="col-8">
          <ul class="list-inline tab-list">
            <li class="list-inline-item ml-2" id="userActive"><a
              (click)="populateValues('active'); getUsersByAccOwnerId('ACTIVE');resetCheckedList();tabChange();"
              [ngClass]="{'active': statusTab === 'active'}">Active</a></li>
            <li class="list-inline-item ml-3" id="userInActive"><a
              (click)="populateValues('inactive'); getUsersByAccOwnerId('IN_ACTIVE');resetCheckedList();tabChange();"
              [ngClass]="{'active': statusTab === 'inactive'}">Inactive</a></li>
            <li class="list-inline-item ml-3" id="userAll"><a
              (click)="populateValues('all'); getUsersByAccOwnerId('ALL');resetCheckedList();tabChange();"
              [ngClass]="{'active': statusTab === 'all'}">All</a></li>
          </ul>
        </div>
        <div class="col-4 text-right float-right">
          <a [hidden]="user.role == 'DEMO_ACCOUNT' && totalCount > 1" class="ml-2" ngbTooltip="Create"
             placement="bottom">
            <img routerLink="/admin/createUser" src="assets/images/create.png"/>
          </a>
        </div>
      </div>
      <div class="inner-box d-none d-sm-block">
        <div class="row">
          <div class="col">
            <div style="overflow-x:auto">
              <table class="table">
                <thead>
                <tr>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let s of users">
                  <td><a routerLink="/admin/editUser/{{s.id}}" style="text-transform:capitalize;">{{s.firstName}}</a>
                  </td>
                  <td style="text-transform:capitalize;">{{s.lastName}}</td>
                  <td>{{s.email}}</td>
                  <td>{{s.mobile}}</td>
                  <td>
                    <div class="toggle-2">
                      <input (click)="changeStatus(s)" [checked]="s.status==='ACTIVE'" class="custom-control-input"
                             class="checkbox"
                             id="customSwitch_{{s.id}}" name="onoffswitch" type="checkbox"/>
                      <label class="toggle" for="customSwitch_{{s.id}}">
                        <span>ON</span><span>OFF</span>
                      </label>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="inner-box d-block d-sm-none">
        <div class="row">
          <div class="col">
            <div style="overflow-x:auto">
              <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
                <thead>
                <tr>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let s of users">
                  <td><b class=" tablesaw-cell-label">First Name </b>
                    <span class="tablesaw-cell-content" style="text-transform:capitalize;"><a
                      routerLink="/admin/editUser/{{s.id}}">{{s.firstName}}</a></span></td>
                  <td><b class=" tablesaw-cell-label">Last Name </b>
                    <span class="tablesaw-cell-content" style="text-transform:capitalize;">{{s.lastName}}</span></td>
                  <td><b class=" tablesaw-cell-label">Email </b>
                    <span class="tablesaw-cell-content">{{s.email}}</span></td>
                  <td><b class=" tablesaw-cell-label">Phone Number</b>
                    <span class="tablesaw-cell-content">{{s.mobile}}</span></td>
                  <td>
                    <b class=" tablesaw-cell-label">Status</b>
                    <span class="tablesaw-cell-content">
                    <div class="custom-control custom-switch">
                      <input (click)="changeStatus(s)" [checked]="s.status==='ACTIVE'" class="custom-control-input"
                             id="customSwitchs_{{s.id}}" type="checkbox">
                      <label class="custom-control-label" for="customSwitchs_{{s.id}}"> </label>
                    </div>
                    </span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div [ngClass]="{'show-sec': tabClicked === 'manageSellers'}" class="row hide-sec">
      <div [hidden]="!errorMessage" class="invalid-feedback d-block shift-invalid-text w-75">{{errorMessage}}</div>
      <div class="row align-items-center">
        <div class="col-8">
          <ul class="list-inline tab-list">
            <li class="list-inline-item ml-2" id="sellerActive"><a
              (click)="populateValues('ACTIVE'); getSellers('ACTIVE');tabChange();"
              [ngClass]="{'active': sellerStatus === 'ACTIVE'}">Active</a></li>
            <li class="list-inline-item ml-3" id="sellerInActive"><a
              (click)="populateValues('IN_ACTIVE'); getSellers('IN_ACTIVE');tabChange();"
              [ngClass]="{'active': sellerStatus === 'IN_ACTIVE'}">Inactive</a></li>
            <li class="list-inline-item ml-3" id="sellerAll"><a
              (click)="populateValues('ALL'); getSellers('ALL');tabChange();"
              [ngClass]="{'active': sellerStatus === 'ALL'}">All</a></li>
          </ul>
        </div>
        <div class="col-4 text-right float-right">
          <a [hidden]="user.role == 'DEMO_ACCOUNT' && totalCount > 1" class="ml-2" ngbTooltip="Create"
             placement="bottom">
            <img routerLink="/admin/createSeller" src="assets/images/create.png"/>
          </a>
        </div>
      </div>
      <div class="inner-box d-none d-sm-block">
        <div class="row">
          <div class="col">
            <div style="overflow-x:auto">
              <table class="table">
                <thead>
                <tr>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Company Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let v of viewSeller">
                  <td><a routerLink="/admin/viewAoSeller/{{v.sellerId}}"
                         style="text-transform:capitalize;">{{v.firstName}}</a>
                  </td>
                  <td style="text-transform:capitalize;">{{v.lastName}}</td>
                  <td>{{v.companyName || '--'}}</td>
                  <td>{{v.email}}</td>
                  <td>{{v.mobile}}</td>
                  <td>
                    <div class="toggle-2">
                      <input (click)="changeSellerStatus(v)" [checked]="v.status==='ACTIVE'"
                             class="custom-control-input"
                             class="checkbox"
                             id="sellerSwitch_{{v.sellerId}}" name="onoffswitch" type="checkbox"/>
                      <label class="toggle" for="sellerSwitch_{{v.sellerId}}">
                        <span>ON</span><span>OFF</span>
                      </label>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="inner-box d-block d-sm-none">
        <div class="row">
          <div class="col">
            <div style="overflow-x:auto">
              <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
                <thead>
                <tr>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let s of users">
                  <td><b class=" tablesaw-cell-label">First Name </b>
                    <span class="tablesaw-cell-content" style="text-transform:capitalize;"><a
                      routerLink="/admin/editUser/{{s.id}}">{{s.firstName}}</a></span></td>
                  <td><b class=" tablesaw-cell-label">Last Name </b>
                    <span class="tablesaw-cell-content" style="text-transform:capitalize;">{{s.lastName}}</span></td>
                  <td><b class=" tablesaw-cell-label">Email </b>
                    <span class="tablesaw-cell-content">{{s.email}}</span></td>
                  <td><b class=" tablesaw-cell-label">Phone Number</b>
                    <span class="tablesaw-cell-content">{{s.mobile}}</span></td>
                  <td>
                    <b class=" tablesaw-cell-label">Status</b>
                    <span class="tablesaw-cell-content">
                    <div class="custom-control custom-switch">
                      <input (click)="changeStatus(s)" [checked]="s.status==='ACTIVE'" class="custom-control-input"
                             id="sellerSwitchs_{{s.id}}" type="checkbox">
                      <label class="custom-control-label" for="sellerSwitchs_{{s.id}}"> </label>
                    </div>
                    </span></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div [ngClass]="{'show-sec': tabClicked === 'notifications'}" class="row hide-sec">
      <div class="row mb-5">
        <div class="col-6">
          <div *ngFor="let notification of notificationsList | slice:0: sliceUPto(notificationsList?.length)"
               class="inner-box">
            <table class="table">
              <thead>
              <tr>
                <th width="25%">Email/SMS</th>
                <th>{{notification.groupName}}</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let n of notification?.notificationTypes">
                <td width="25%">
                  <div class="toggle-2">
                    <input (change)="updateStatus(n,notification.id)" [(ngModel)]="n.enabled"
                           [ngModelOptions]="{standalone: true}" class="custom-control-input"
                           class="checkbox" id="{{n.typeName}}"
                           name="onoffswitch" type="checkbox"/>
                    <label class="toggle" for="{{n.typeName}}">
                      <span>ON</span><span>OFF</span>
                    </label>
                  </div>
                </td>
                <td>{{n?.typeName}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-6">
          <div
            *ngFor="let notification of notificationsList | slice:sliceUPto(notificationsList?.length):notificationsList?.length"
            class="inner-box">
            <table class="table">
              <thead>
              <tr>
                <th width="25%">Email/SMS</th>
                <th>{{notification.groupName}}</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let n of notification?.notificationTypes">
                <td width="25%">
                  <div class="toggle-2">
                    <input (change)="updateStatus(n,notification.id)" [(ngModel)]="n.enabled"
                           [ngModelOptions]="{standalone: true}" class="custom-control-input"
                           class="checkbox" id="c-{{n.typeName}}"
                           name="onoffswitch" type="checkbox"/>
                    <label class="toggle" for="c-{{n.typeName}}">
                      <span>ON</span><span>OFF</span>
                    </label>
                  </div>
                </td>
                <td>{{n?.typeName}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div [ngClass]="{'show-sec': tabClicked === 'shippingPreference'}" class="row hide-sec">
      <div class="inner-box deskContent">
        <div class="row">
          <div class="col">
            <div class="row">
              <div class="col border-right">
                <div class="row-box ">
                  <div class="row border-bottom">
                    <div class="col-md-6"><b>Carrier Type</b></div>
                    <div class="col-md-5">
                      <b>Preference</b>
                    </div>
                  </div>
                  <div *ngFor="let p of carriersList;let s of shipPreferences;let i = index;">
                    <div class="row border-bottom align-items-center">
                      <div class="col-md-6">
                        <img style="width:18px;" src="assets/images/1-{{p.name}}.png">
                        <label class="ml-2">{{p.label}}</label>
                      </div>
                      <div class="col-md-5">
                        <select (change)="selectedPreferences(i,p,s)" [(ngModel)]="carrierPreference[i]"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control" id="preference"
                                required>
                          <option *ngFor="let c of carriersPreferencesList" [ngValue]="c.config">
                            {{c.label}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="inner-box MobileContent">
        <label class="text-black mb-3"><b>Carrier Preference</b></label>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group ">
              <label class="control-label" for="shipmentMode">Carrier Choice</label>
              <select [(ngModel)]="shippingMode" [ngModelOptions]="{standalone: true}" class="form-control"
                      class="form-control" id="shipmentMode" required>
                <option value="OWN">Own</option>
                <option value="SHIFT">Shift</option>
                <option value="ThirdParty">Third Party</option>
              </select>

              <div [hidden]="!shippingModeError" class="invalid-feedback d-block shift-invalid-login"
                   id="shippingModeError">{{shippingModeError}}
              </div>

            </div>
          </div>
        </div>
        <div class="row">
          <div *ngIf="shippingMode == 'ThirdParty'" class="col-md-4">
            <div class="form-group ">
              <label class="control-label" for="carrier">Third-Party Carriers</label>
              <select [(ngModel)]="carrierMode" [ngModelOptions]="{standalone: true}" class="form-control" id="carrier"
                      required>
                <option value="DELIVERY">Delivery</option>
                <option value="FEDEX">Fed Ex</option>
                <option value="BLUE_DART">Blue Dart</option>
                <option value="FIRST">First Dart</option>
                <option value="SHIFT">Shift</option>
              </select>


              <div [hidden]="!carrierModeError" class="invalid-feedback d-block shift-invalid-login"
                   id="carrierModeError">{{carrierModeError}}
              </div>

            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col text-right">
            <button (click)="submitShippingLabel()" class="btn btn-orange" id="notificationSave" type="button">Save
            </button>
          </div>
        </div>
      </div>

    </div>

    <div [ngClass]="{'show-sec': tabClicked === 'labelPreferences'}" class="row hide-sec">
      <div class="inner-box">
        <label class="text-black mb-3"><b>Label Preference</b></label>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group ">
              <label class="control-label" for="printTypeCommonPage">Preferred Label Format</label>
              <select [(ngModel)]="printTypeCommonPage" [ngModelOptions]="{standalone: true}" class="form-control"
                      id="printTypeCommonPage">
                <option>24 labels with 63mm X 34mm</option>
                <option>33 labels with 63mm X 34mm</option>
                <option>40 labels with 63mm X 34mm</option>
                <option>48 labels with 63mm X 34mm</option>
              </select>
              <div [hidden]="!printTypeCommonPageError" class="invalid-feedback d-block shift-invalid-login"
                   id="printTypeCommonPageError">{{printTypeCommonPageError}}
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col text-right">
            <button (click)="submitLabelPreference()" class="btn btn-orange" id="labelSave" type="button">Save</button>
          </div>
        </div>
      </div>


    </div>
    <div [ngClass]="{'show-sec': tabClicked === 'packaging'}" class="row hide-sec">
      <div class="inner-box">
        <label class="text-black mb-3"><b>Packaging</b></label>
      </div>
    </div>

    <div [ngClass]="{'show-sec': tabClicked === 'orderPreference'}" class="row hide-sec">
      <div class="inner-box">
        <label class="text-black mb-3"><b>Invoice</b></label>
        <div class="toggle-2">
          <input type="checkbox" id="scheduleOrdersCB" name="Schedule" (change)="submitAll()"
                 [checked]="orderPreferences.invoicePreference == 'Yes'" class="custom-control-input checkbox">
          <label for="scheduleOrdersCB" class="toggle">
            <span>ON</span><span>OFF</span>
          </label>

          <label _ngcontent-wtg-c8="">
            <label _ngcontent-noa-c8="" _ngcontent-hmd-c11="" class="ms-4">Is Invoice Mandatory while Delivering
              Orders</label>
          </label>
        </div>
        <hr>

        <label class="text-black mb-3"><b>Auto process order</b></label>
        <div class="toggle-2">
          <input type="checkbox" id="scheduleOrdersCB1" name="Schedule" (change)="autoProcessOrder()"
                 [checked]="orderPreferences.autoOrderPreference == 'Yes'" class="custom-control-input checkbox">
          <label for="scheduleOrdersCB1" class="toggle">
            <span>ON</span><span>OFF</span>
          </label>
          <label _ngcontent-noa-c8="" _ngcontent-hmd-c11="" class="ms-4">Enabling This option will auto process the
            orders after stock validation</label>
        </div>
        <hr>
        <label class="text-black mb-3"><b>Package configuration</b></label>
        <div class="col-6" *ngFor="let singleCheckBox of packageConfiguration">
          <div class="form-check">
            <input type="checkbox" class="form-check-input" (change)="productConfigSelection()"
                   (change)="changePackage($event.target.checked, singleCheckBox)"
                   [checked]="checkedServices(singleCheckBox)">
            <label>{{singleCheckBox}}</label>
          </div>
        </div>
        <label class="btn icon-right btn-orange-primary ml-3 float:right"></label>
      </div>
    </div>
  </form>
</section>

<div aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal fade style-modal" id="upLoadImage"
     role="dialog"
     tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content modal-content-shift">
      <div class="modal-body">
        <div class="form-group btn-upload">
          <label
            [ngStyle]="{'background-image':'url('+ productImage +')', 'background-position': 'center', 'background-size': 'cover'}"
            class="shift-upload-img"
            for="file"
            style="width:234px; height:200px"></label>
          <input (change)="loadImage($event)" accept="image/*" class="form-control-file" id="file" type="file">
        </div>
        <div class="mt-2">
          <button (click)="ignoreImage()" class="btn btn-cancel" data-dismiss="modal" id="cancel" type="button">Cancel
          </button>
          <button (click)="submitImage()" class="btn btn-cancel-okay ml-1 text-white" data-dismiss="modal"
                  data-toggle="modal"
                  id="ok" type="button">Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Account Delete model-box-->
<div class="container">
  <div class="modal fade" id="deleteAccount" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Delete Confirmation</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <p>Are you sure you want to delete your account ?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-delete" data-dismiss="modal">No</button>
          <button type="button" class="btn btn-edit" data-dismiss="modal" (click)="confirmDelete()">Yes</button>
        </div>
      </div>
    </div>
  </div>
</div>
